export interface AnimePost {
  id: string;
  category: "recommend" | "avoid" | "order" | "review";
  title: string;
  excerpt: string;
  tags: string[];
  author: string;
  date: string;
  views: string;
  likes: string;
  image: string;
  badge?: string;
  rating?: number;
}

export interface CategoryItem {
  id: string;
  name: string;
  title: string;
  desc: string;
  tagline: string;
  slug: string;
  icon: string;
  image: string;
}

export const categories: CategoryItem[] = [
  {
    id: "recommend",
    name: "求番推荐",
    title: "求番推荐 · 不知道该看什么",
    desc: "把你的偏好丢进来，同好帮你把下一部要追的番选出来。热血、治愈、悬疑、恋爱，来问就有人答。",
    tagline: "不知道下一部看什么，来这里问",
    slug: "/recommend",
    icon: "ri-search-eye-line",
    image: "https://readdy.ai/api/search-image?query=Vibrant%20anime%20illustration%20of%20a%20young%20seeker%20holding%20a%20glowing%20magnifying%20glass%20over%20a%20stack%20of%20colorful%20manga%20volumes%2C%20warm%20coral%20orange%20and%20amber%20gold%20palette%2C%20soft%20cream%20background%2C%20dynamic%20energetic%20flat%20vector%20art%2C%20clean%20modern%20anime%20community%20style&width=800&height=600&seq=cat-recommend-1&orientation=landscape",
  },
  {
    id: "avoid",
    name: "避雷指南",
    title: "避雷指南 · 帮你少踩一个坑",
    desc: "烂尾、崩坏、节奏拖沓、设定崩盘……老番新番的雷点一次说清，让每一分钟都花在好番上。",
    tagline: "烂番不踩坑，时间不白花",
    slug: "/avoid",
    icon: "ri-shield-cross-line",
    image: "https://readdy.ai/api/search-image?query=Vibrant%20anime%20illustration%20of%20a%20shield%20blocking%20cracked%20broken%20film%20reels%20and%20warning%20bombs%2C%20warm%20coral%20and%20amber%20tones%2C%20soft%20cream%20background%2C%20flat%20vector%20art%2C%20clean%20modern%20anime%20community%20style&width=800&height=600&seq=cat-avoid-1&orientation=landscape",
  },
  {
    id: "order",
    name: "补番顺序",
    title: "补番顺序 · 老番一次补到位",
    desc: "连载顺序、剧情顺序、时间线顺序一次理清，追老番不再混乱，补番党福音。",
    tagline: "按顺序补完老番，一站搞定",
    slug: "/order",
    icon: "ri-list-check-3",
    image: "https://readdy.ai/api/search-image?query=Vibrant%20anime%20illustration%20of%20a%20film%20strip%20timeline%20with%20numbered%20steps%20and%20a%20play%20button%2C%20warm%20coral%20orange%20and%20amber%20palette%2C%20soft%20cream%20background%2C%20flat%20vector%20art%2C%20clean%20modern%20anime%20community%20style&width=800&height=600&seq=cat-order-1&orientation=landscape",
  },
  {
    id: "review",
    name: "漫评讨论",
    title: "漫评讨论 · 与同好聊到天亮",
    desc: "私藏安利、深度漫评、剧情脑洞与角色分析，在这里和同好分享你的热爱与观点。",
    tagline: "私藏安利与漫评，同好畅聊",
    slug: "/review",
    icon: "ri-chat-3-line",
    image: "https://readdy.ai/api/search-image?query=Vibrant%20anime%20illustration%20of%20fans%20chatting%20around%20a%20glowing%20speech%20bubble%20with%20manga%20patterns%2C%20warm%20coral%20and%20amber%20tones%2C%20soft%20cream%20background%2C%20flat%20vector%20art%2C%20clean%20modern%20anime%20community%20style&width=800&height=600&seq=cat-review-1&orientation=landscape",
  },
];

export const heroImage =
  "https://readdy.ai/api/search-image?query=Panoramic%20vibrant%20anime%20illustration%20of%20a%20bustling%20sunset%20city%20filled%20with%20young%20anime%20characters%20watching%20big%20screens%20and%20sharing%20manga%2C%20warm%20coral%20orange%20and%20amber%20gold%20color%20palette%2C%20soft%20cream%20sky%2C%20dynamic%20energetic%20flat%20vector%20art%2C%20clean%20modern%20anime%20community%20style&width=1600&height=900&seq=anime-hero-2026&orientation=landscape";

export const posts: AnimePost[] = [
  {
    id: "rec-1",
    category: "recommend",
    title: "热血打斗党进！这几部战斗爽番闭眼入",
    excerpt: "如果你就是冲着打斗画面和燃到爆的节奏来的，这份私藏清单里每一部都值得周末一口气刷完。从拳拳到肉的硬派格斗到花哨到极致的特效流，总有一款对上你的口味。",
    tags: ["热血", "战斗", "爽番"],
    author: "雾岛藏",
    date: "2026-08-12",
    views: "8.2k",
    likes: "1.4k",
    image: "https://readdy.ai/api/search-image?query=Vibrant%20anime%20illustration%20of%20two%20fighters%20clashing%20with%20fiery%20energy%20bursts%20in%20an%20arena%2C%20warm%20coral%20orange%20and%20amber%20tones%2C%20soft%20cream%20background%2C%20flat%20vector%20art%2C%20dynamic%20action%20composition%2C%20modern%20anime%20community%20style&width=640&height=400&seq=post-rec1-1&orientation=landscape",
    badge: "编辑精选",
    rating: 9.2,
  },
  {
    id: "rec-2",
    category: "recommend",
    title: "治愈系天花板：看完心都化了的小清新番",
    excerpt: "忙了一整天回到家，只想看点不烧脑又温暖的？这份治愈清单选番讲究一个「看完想给身边的人一个大大的拥抱」。日常、治愈、温馨，配饭绝佳。",
    tags: ["治愈", "日常", "温馨"],
    author: "momo酱",
    date: "2026-08-10",
    views: "6.7k",
    likes: "2.1k",
    image: "https://readdy.ai/api/search-image?query=Vibrant%20anime%20illustration%20of%20a%20cozy%20tearoom%20scene%20with%20warm%20steaming%20cups%20and%20soft%20sunlight%20through%20window%2C%20warm%20coral%20and%20amber%20palette%2C%20soft%20cream%20background%2C%20flat%20vector%20art%2C%20gentle%20relaxing%20composition%2C%20modern%20anime%20community%20style&width=640&height=400&seq=post-rec2-1&orientation=landscape",
    badge: "私藏安利",
    rating: 9.0,
  },
  {
    id: "rec-3",
    category: "recommend",
    title: "悬疑烧脑爱好者点名：高智商博弈强推番",
    excerpt: "反转再反转，每一集都在猜谁是幕后黑手。喜欢动脑子、喜欢细思极恐的朋友，这份悬疑清单从入门到进阶都给你排好了，看完一定回来谢我。",
    tags: ["悬疑", "烧脑", "反转"],
    author: "夜游神",
    date: "2026-08-08",
    views: "9.1k",
    likes: "1.9k",
    image: "https://readdy.ai/api/search-image?query=Vibrant%20anime%20illustration%20of%20a%20mysterious%20detective%20standing%20in%20a%20dim%20room%20with%20glowing%20clue%20threads%20connecting%20cards%2C%20warm%20coral%20and%20amber%20tones%2C%20soft%20cream%20background%2C%20flat%20vector%20art%2C%20intriguing%20composition%2C%20modern%20anime%20community%20style&width=640&height=400&seq=post-rec3-1&orientation=landscape",
    badge: "同好强推",
    rating: 9.4,
  },
  {
    id: "avoid-1",
    category: "avoid",
    title: "避雷！这部高开低走的烂尾番别浪费时间",
    excerpt: "开局神作、结局稀碎，是不少老番新番的通病。这篇把口碑崩盘的关键节点、节奏问题和你最该避开的集数一次说清，帮你省下宝贵的补番时间。",
    tags: ["避雷", "烂尾", "高开低走"],
    author: "避雷雷达",
    date: "2026-08-11",
    views: "12.3k",
    likes: "3.0k",
    image: "https://readdy.ai/api/search-image?query=Vibrant%20anime%20illustration%20of%20a%20warning%20sign%20next%20to%20a%20collapsing%20tower%20of%20cracked%20manga%20volumes%2C%20warm%20coral%20and%20amber%20tones%2C%20soft%20cream%20background%2C%20flat%20vector%20art%2C%20clear%20warning%20composition%2C%20modern%20anime%20community%20style&width=640&height=400&seq=post-av1-1&orientation=landscape",
    badge: "热议避雷",
    rating: 9.1,
  },
  {
    id: "avoid-2",
    category: "avoid",
    title: "制作崩坏预警：画面崩到劝退的番有哪些",
    excerpt: "作画崩坏、分镜混乱、演出敷衍……这些「制作雷区」让再好的剧本也救不回来。想躲开这类番，先认准这些肉眼可见的崩坏信号。",
    tags: ["作画", "制作崩坏", "劝退"],
    author: "分镜评审员",
    date: "2026-08-07",
    views: "7.8k",
    likes: "1.6k",
    image: "https://readdy.ai/api/search-image?query=Vibrant%20anime%20illustration%20of%20a%20cracked%20screen%20with%20broken%20pixel%20animation%20frames%20falling%20apart%2C%20warm%20coral%20and%20amber%20tones%2C%20soft%20cream%20background%2C%20flat%20vector%20art%2C%20clear%20warning%20composition%2C%20modern%20anime%20community%20style&width=640&height=400&seq=post-av2-1&orientation=landscape",
    badge: "避雷精选",
    rating: 8.8,
  },
  {
    id: "avoid-3",
    category: "avoid",
    title: "节奏拖沓警告：前期劝退、后期封神的真实评价",
    excerpt: "有些番前期是真的劝退，但熬过前面几集就能封神。这篇帮你判断哪些「忍一忍就过去了」，哪些是真该早点弃番止损。",
    tags: ["节奏", "前期劝退", "神作"],
    author: "追番老手",
    date: "2026-08-05",
    views: "5.9k",
    likes: "1.1k",
    image: "https://readdy.ai/api/search-image?query=Vibrant%20anime%20illustration%20of%20a%20clock%20and%20film%20reel%20with%20a%20bored%20viewer%20yawning%20then%20a%20sparkling%20glow%2C%20warm%20coral%20and%20amber%20tones%2C%20soft%20cream%20background%2C%20flat%20vector%20art%2C%20modern%20anime%20community%20style&width=640&height=400&seq=post-av3-1&orientation=landscape",
    badge: "追番心得",
    rating: 8.6,
  },
  {
    id: "order-1",
    category: "order",
    title: "老番补番顺序全攻略：从入坑到毕业的路线图",
    excerpt: "面对几十集的经典老番，先看哪部、按什么顺序补才不会乱了剧情线？这篇整理了一份循序渐进的补番路线，让你从入坑小白顺利毕业成老番达人。",
    tags: ["补番攻略", "入坑指南", "经典"],
    author: "补番规划师",
    date: "2026-08-13",
    views: "15.7k",
    likes: "4.2k",
    image: "https://readdy.ai/api/search-image?query=Vibrant%20anime%20illustration%20of%20a%20winding%20path%20through%20numbered%20manga%20shelves%20with%20arrow%20signs%2C%20warm%20coral%20orange%20and%20amber%20palette%2C%20soft%20cream%20background%2C%20flat%20vector%20art%2C%20clear%20guide%20composition%2C%20modern%20anime%20community%20style&width=640&height=400&seq=post-od1-1&orientation=landscape",
    badge: "必读攻略",
    rating: 9.5,
  },
  {
    id: "order-2",
    category: "order",
    title: "长篇大作的正确打开方式：连载顺序 vs 剧情顺序",
    excerpt: "长篇番往往连载顺序和剧情时间线并不一致，搞错了顺序轻则剧透重则劝退。这篇把两种补法讲透，帮你决定哪一种最适合自己。",
    tags: ["长篇", "连载顺序", "时间线"],
    author: "时间线管理员",
    date: "2026-08-09",
    views: "9.8k",
    likes: "2.6k",
    image: "https://readdy.ai/api/search-image?query=Vibrant%20anime%20illustration%20of%20two%20diverging%20film%20timelines%20one%20straight%20one%20swirling%20with%20date%20markers%2C%20warm%20coral%20and%20amber%20tones%2C%20soft%20cream%20background%2C%20flat%20vector%20art%2C%20modern%20anime%20community%20style&width=640&height=400&seq=post-od2-1&orientation=landscape",
    badge: "干货帖",
    rating: 9.3,
  },
  {
    id: "order-3",
    category: "order",
    title: "这几部番千万别按播出顺序看，正确顺序在这",
    excerpt: "有些番的正确观看顺序和播出顺序完全相反，甚至要先看剧场版或外传。这篇把容易踩错的几部番的正确补法一一列给你。",
    tags: ["观看顺序", "剧场版", "外传"],
    author: "补番老司机",
    date: "2026-08-03",
    views: "11.2k",
    likes: "3.3k",
    image: "https://readdy.ai/api/search-image?query=Vibrant%20anime%20illustration%20of%20a%20reordered%20film%20strip%20being%20reassembled%20with%20arrows%20and%20number%20badges%2C%20warm%20coral%20and%20amber%20tones%2C%20soft%20cream%20background%2C%20flat%20vector%20art%2C%20clear%20order%20composition%2C%20modern%20anime%20community%20style&width=640&height=400&seq=post-od3-1&orientation=landscape",
    badge: "干货帖",
    rating: 9.0,
  },
  {
    id: "review-1",
    category: "review",
    title: "十年老粉深度漫评：这部经典为什么至今封神",
    excerpt: "一部十年前的作品，为什么到今天依然被反复讨论？这篇从主题、角色到制作层层拆解，聊聊它打动一代人的真正原因。",
    tags: ["深度漫评", "经典", "神作"],
    author: "观影人阿澈",
    date: "2026-08-14",
    views: "10.4k",
    likes: "3.8k",
    image: "https://readdy.ai/api/search-image?query=Vibrant%20anime%20illustration%20of%20a%20group%20of%20iconic%20characters%20silhouettes%20under%20a%20glowing%20spotlight%20on%20a%20stage%2C%20warm%20coral%20and%20amber%20tones%2C%20soft%20cream%20background%2C%20flat%20vector%20art%2C%20cinematic%20composition%2C%20modern%20anime%20community%20style&width=640&height=400&seq=post-rv1-1&orientation=landscape",
    badge: "深度长文",
    rating: 9.6,
  },
  {
    id: "review-2",
    category: "review",
    title: "私藏安利：被低估的冷门佳作，宝藏番分享",
    excerpt: "很多冷门番被埋没在热度之外，其实制作和故事都不输热门大作。这篇把我压箱底的宝藏冷门番全部安利出来，错过真的可惜。",
    tags: ["冷门佳作", "私藏安利", "宝藏"],
    author: "冷门挖掘机",
    date: "2026-08-06",
    views: "7.2k",
    likes: "2.4k",
    image: "https://readdy.ai/api/search-image?query=Vibrant%20anime%20illustration%20of%20a%20treasure%20chest%20opening%20with%20glowing%20manga%20books%20and%20stars%20flying%20out%2C%20warm%20coral%20and%20amber%20tones%2C%20soft%20cream%20background%2C%20flat%20vector%20art%2C%20modern%20anime%20community%20style&width=640&height=400&seq=post-rv2-1&orientation=landscape",
    badge: "宝藏安利",
    rating: 9.1,
  },
  {
    id: "review-3",
    category: "review",
    title: "剧情脑洞大开：这部番的伏笔你发现了几处",
    excerpt: "好的番从来不是看一遍就完，每一处台词、每个镜头都可能是埋好的伏笔。这篇带你把隐藏的细节和彩蛋逐帧找出来，重新打开新世界。",
    tags: ["剧情脑洞", "伏笔", "细节"],
    author: "细节控",
    date: "2026-08-02",
    views: "6.3k",
    likes: "1.8k",
    image: "https://readdy.ai/api/search-image?query=Vibrant%20anime%20illustration%20of%20a%20magnifying%20glass%20revealing%20hidden%20easter%20egg%20symbols%20in%20a%20storyboard%20scene%2C%20warm%20coral%20and%20amber%20tones%2C%20soft%20cream%20background%2C%20flat%20vector%20art%2C%20modern%20anime%20community%20style&width=640&height=400&seq=post-rv3-1&orientation=landscape",
    badge: "同好热议",
    rating: 8.9,
  },
];

export const trendingList: AnimePost[] = [
  posts.find((p) => p.id === "order-1")!,
  posts.find((p) => p.id === "avoid-1")!,
  posts.find((p) => p.id === "review-1")!,
  posts.find((p) => p.id === "rec-3")!,
];

export const avoidHighlights: AnimePost[] = [
  posts.find((p) => p.id === "avoid-1")!,
  posts.find((p) => p.id === "avoid-2")!,
  posts.find((p) => p.id === "avoid-3")!,
];

export const orderGuides: AnimePost[] = [
  posts.find((p) => p.id === "order-1")!,
  posts.find((p) => p.id === "order-2")!,
  posts.find((p) => p.id === "order-3")!,
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  {
    q: "新御宅屋是做什么的？",
    a: "新御宅屋是一个动漫同好社区，聚集了一批热爱看番的朋友。你可以在这里求番推荐、浏览私藏安利、参与漫评讨论，还有详细的避雷指南与补番顺序攻略，帮你决定下一部看什么。",
  },
  {
    q: "不知道下一部看什么，可以在这里问吗？",
    a: "当然可以。在「求番推荐」栏目里，把你看番的偏好（热血、治愈、悬疑、恋爱等）和最近在追的类型留言出来，同好们会帮你筛选出最适合你的那部番。",
  },
  {
    q: "「避雷指南」里的评价客观吗？",
    a: "避雷指南由多位资深追番同好撰写，会从节奏、作画、剧情、烂尾风险等多个角度给出真实体验和明确的避雷建议，并结合站内同好的口碑综合整理，尽量客观有参考价值。",
  },
  {
    q: "怎么知道老番的正确补番顺序？",
    a: "「补番顺序」栏目整理了各类经典老番的观看路线，包括连载顺序、剧情时间线顺序、剧场版与正片的衔接等，按攻略来补就不会出现剧情混乱或误剧透的情况。",
  },
  {
    q: "我能自己投稿安利或漫评吗？",
    a: "欢迎所有同好分享自己的私藏安利与漫评。你可以通过站内的投稿/联系入口提交内容，我们会审核后发布，优质内容还会被推荐到首页的精选位置。",
  },
];

export const testimonials = [
  {
    name: "阿凯",
    role: "入坑两年的新同好",
    text: "以前选番全靠封面赌运气，自从有了新御宅屋的避雷指南，踩坑率直线下降，时间全花在好番上了。",
    color: "primary",
  },
  {
    name: "小满",
    role: "补番党一枚",
    text: "补番顺序攻略救了大命，长篇番再也不用怕搞混时间线了，按攻略补完一整个系列，太满足了。",
    color: "accent",
  },
  {
    name: "Leo",
    role: "十年老宅",
    text: "在这里能找到聊得来的同好，安利和漫评都很有深度，是我每天必刷的动漫社区。",
    color: "secondary",
  },
];